import type { ComponentProps } from 'react'
import { classNames } from '~/utils/client/helpers'

type TableActionsProps = {
  className?: string
} & ComponentProps<'div'>

type TableActionProps = {
  className?: string
  width?: 'half' | 'quarter' | 'full' | 'three-quarters'
} & ComponentProps<'div'>

export const TableAction = ({
  className,
  children,
  width = 'half',
  ...props
}: TableActionProps) => {
  const widthName =
    width === 'full'
      ? 'md:col-span-4'
      : width === 'quarter'
      ? 'md:col-span-1'
      : width === 'three-quarters'
      ? 'md:col-span-3'
      : 'md:col-span-2'

  return <div className={classNames('w-full col-span-1', widthName, className)}>{children}</div>
}

export const TableActions = ({ className, children, ...props }: TableActionsProps) => {
  return (
    <div
      className={classNames('grid grid-cols-1 md:grid-cols-4 items-end p-4 gap-4', className)}
      {...props}
    >
      {children}
    </div>
  )
}
